/**
 * @file Automatically generated by barrelsby.
 */

export * from './ng2-typeahead.module';
export * from './ng2-typeahead';
